import React from 'react';
import { Input as AntInput, Alert } from 'antd';

const Form = ({ children, errorMessage, ...rest }) => {
  return (
    <form {...rest}>
      {children}
      {errorMessage && <Alert description={errorMessage} type="error" />}
    </form>
  );
};

const Input = ({ name, label, error, disabled, ...rest }) => {
  return (
    <>
      {label && <Label htmlFor={name}>{label}</Label>}
      <AntInput
        id={name}
        name={name}
        disabled={disabled}
        className="p-4 my-2 h-auto text-lg border rounded-none"
        {...rest}
      />
      {error && <div className="text-red-600">{error.message}</div>}
    </>
  );
};

const Label = ({ children, ...rest }) => {
  return <label {...rest}>{children}</label>;
};

export default Form;

export { Input, Label };
